export const headerNav = [
  { label: '首页', href: '#hero' },
  { label: '平台介绍', href: '#about' },
  { label: 'APP下载', href: '#app' },
  { label: '视频专区', href: '#media' },
  { label: '联系我们', href: '#contact' },
  { label: '精选专题', href: '#carousel' },
];

export const aboutData = {
  title: '关于包子漫画',
  description: '包子漫画是国内领先的免费漫画在线阅读平台，致力于为广大漫画爱好者提供最新、最全、最高清的漫画资源。平台收录超过10万部漫画作品，涵盖韩漫、日漫、国漫等多种类型，从热血战斗到甜蜜恋爱，从悬疑惊悚到轻松搞笑，应有尽有。我们坚持每日更新，确保读者第一时间追更心仪作品，所有内容完全免费，无需注册付费即可畅享完整阅读体验。',
  stats: [
    { value: '10万+', label: '漫画资源' },
    { value: '每日更新', label: '更新频率' },
    { value: '500万+', label: '月活用户' },
  ],
};

export const featuresData = [
  {
    icon: 'ri-book-open-line',
    title: '海量免费漫画',
    description: '收录超过10万部韩漫、日漫、国漫作品，全部免费畅读，每周持续上新热门新作，追番永不断档。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式畅快阅读',
    description: '专为移动端优化的竖屏下拉阅读模式，无需翻页即可连贯浏览，还原纸质漫画沉浸体验。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日极速更新',
    description: '热门连载每日同步更新，第一时间推送最新话，让你永远走在追更第一线，精彩不错过。',
  },
];

export const contactData = {
  title: '联系我们',
  description: '欢迎漫画作者、汉化组、版权方与我们合作。如果你有优质漫画作品希望推广，或有任何建议和反馈，请随时通过以下方式联系我们。',
  email: 'contact@baozimanhua.com',
  qq: '1234567890',
  wechat: 'baozimanhua',
};

export const topicsData = [
  { label: '韩漫推荐', hot: true, count: '3.2万' },
  { label: '恋爱漫画', hot: true, count: '5.8万' },
  { label: '热血战斗', hot: false, count: '4.1万' },
  { label: '悬疑惊悚', hot: true, count: '1.9万' },
  { label: '搞笑日常', hot: false, count: '2.7万' },
  { label: '古风国漫', hot: true, count: '3.5万' },
  { label: '奇幻冒险', hot: false, count: '2.3万' },
  { label: '都市言情', hot: true, count: '6.1万' },
  { label: '完结神作', hot: false, count: '8.4万' },
];

export const carouselData = [
  {
    title: '《女神降临》—— 化妆变脸逆袭校园',
    summary: '丑小鸭变天鹅的经典韩漫力作，任晶晶通过化妆术完成惊艳蜕变，校园恋爱与友情交织，千万读者追更的国民级漫画。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20stunning%20young%20woman%20with%20long%20dark%20hair%20transforming%20from%20shy%20to%20confident%2C%20soft%20pastel%20background%20with%20sparkling%20effects%2C%20romantic%20school%20atmosphere%2C%20digital%20art%2C%20warm%20lighting%2C%20clean%20composition&width=800&height=500&seq=carousel-1&orientation=landscape',
    tag: '韩漫 · 恋爱',
  },
  {
    title: '《我独自升级》—— 从最弱到最强的逆袭',
    summary: '全球现象级韩漫，E级猎人程肖宇在地下城获得"系统"能力，一步步成长为最强猎人的热血史诗，战斗场面炸裂。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20warrior%20with%20dark%20armor%20and%20glowing%20blue%20eyes%20standing%20in%20a%20dungeon%2C%20dramatic%20lighting%20with%20particles%2C%20intense%20atmosphere%2C%20digital%20art%2C%20motion%20effects%2C%20dark%20fantasy%20aesthetic&width=800&height=500&seq=carousel-2&orientation=landscape',
    tag: '韩漫 · 热血',
  },
  {
    title: '《间谍过家家》—— 伪装家庭的温馨喜剧',
    summary: '间谍父亲、杀手母亲、读心术女儿组成的伪装家庭，在搞笑日常中守护世界和平，日漫年度销量冠军之作。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20family%20of%20three%20with%20a%20suited%20man%2C%20elegant%20woman%2C%20and%20cute%20little%20girl%20with%20pink%20hair%2C%20warm%20living%20room%20background%2C%20comedy%20atmosphere%2C%20clean%20line%20art%2C%20soft%20colors&width=800&height=500&seq=carousel-3&orientation=landscape',
    tag: '日漫 · 搞笑',
  },
  {
    title: '《天官赐福》—— 绝美国风仙侠传奇',
    summary: '墨香铜臭原著改编古风国漫，谢怜与花城跨越八百年的仙侠情缘，精美画风与宏大世界观完美呈现东方玄幻之美。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20fantasy%20illustration%20of%20two%20elegant%20male%20immortals%20in%20flowing%20white%20and%20red%20robes%20floating%20among%20clouds%20and%20cherry%20blossoms%2C%20celestial%20palace%20background%2C%20traditional%20Chinese%20art%20style%2C%20soft%20ethereal%20lighting&width=800&height=500&seq=carousel-4&orientation=landscape',
    tag: '国漫 · 古风',
  },
];

export const appData = {
  title: '随时随地免费看漫画',
  description: '下载包子漫画APP，享受更流畅的阅读体验。支持离线下载、夜间模式、智能推荐，让好漫画触手可及。',
  features: ['离线下载随时看', '夜间模式护眼', '个性化推荐', '更新即时提醒'],
  qrImage: 'https://readdy.ai/api/search-image?query=A%20simple%20clean%20QR%20code%20style%20pattern%20on%20white%20background%20with%20a%20small%20comic%20speech%20bubble%20icon%20in%20the%20center%2C%20minimalist%20design%2C%20high%20contrast%2C%20clean%20geometric%20pattern&width=300&height=300&seq=app-qr&orientation=squarish',
};

export const cardsData = [
  {
    title: '前世今生',
    subtitle: '韩漫 · 奇幻恋爱',
    description: '意外穿越到古代朝鲜，她能否改变既定的命运轨迹？一段跨时空的浪漫爱情故事。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20beautiful%20woman%20in%20traditional%20Korean%20hanbok%20dress%20with%20modern%20elements%2C%20soft%20romantic%20atmosphere%2C%20cherry%20blossom%20petals%2C%20pastel%20colors%2C%20clean%20simple%20art&width=400&height=560&seq=card-1&orientation=portrait',
    tag: '热门连载',
  },
  {
    title: '修罗武神',
    subtitle: '国漫 · 玄幻热血',
    description: '少年楚枫觉醒逆天血脉，一路碾压强敌踏上武道巅峰，爽快战斗与燃爆剧情。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20style%2C%20young%20martial%20artist%20male%20with%20flowing%20long%20hair%20and%20ancient%20Chinese%20warrior%20robe%2C%20holding%20a%20sword%2C%20dramatic%20wind%20effects%2C%20warm%20golden%20and%20red%20tones&width=400&height=560&seq=card-2&orientation=portrait',
    tag: '每日更新',
  },
  {
    title: '社长大人请自重',
    subtitle: '韩漫 · 都市言情',
    description: '新入职的小职员意外发现霸道社长的秘密，从此开始了啼笑皆非的办公室恋情。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manhwa%20cover%20style%2C%20handsome%20businessman%20in%20suit%20and%20pretty%20office%20lady%2C%20modern%20office%20setting%2C%20romantic%20tension%2C%20soft%20lighting%2C%20Korean%20webtoon%20art%20style&width=400&height=560&seq=card-3&orientation=portrait',
    tag: '新作上线',
  },
  {
    title: '深渊游戏',
    subtitle: '日漫 · 悬疑冒险',
    description: '被困在神秘虚拟游戏的玩家们必须通关才能逃脱，每一步都充满致命陷阱。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20suspense%20manga%20cover%20style%2C%20a%20character%20in%20futuristic%20game%20world%20with%20neon%20lights%20and%20shadows%2C%20mysterious%20atmosphere%2C%20cool%20blue%20and%20purple%20tones%2C%20digital%20art&width=400&height=560&seq=card-4&orientation=portrait',
    tag: '高分推荐',
  },
  {
    title: '天后进化论',
    subtitle: '国漫 · 娱乐圈',
    description: '从练习生到顶流天后，她凭借实力和颜值征服娱乐圈，揭开光鲜背后的真实故事。',
    image: 'https://readdy.ai/api/search-image?query=Glamorous%20manhua%20cover%20style%2C%20beautiful%20female%20pop%20star%20on%20stage%20with%20spotlight%20and%20sparkling%20effects%2C%20modern%20fashion%2C%20dazzling%20atmosphere%2C%20warm%20golden%20lighting&width=400&height=560&seq=card-5&orientation=portrait',
    tag: '人气飙升',
  },
  {
    title: '废柴逆天',
    subtitle: '韩漫 · 逆袭爽文',
    description: '被家族抛弃的废柴少年意外获得远古传承，开启碾压模式，曾经的嘲笑者纷纷跪求原谅。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20style%2C%20young%20man%20with%20determined%20expression%20surrounded%20by%20glowing%20energy%20aura%2C%20fantasy%20elements%2C%20dramatic%20pose%2C%20warm%20golden%20and%20orange%20lighting&width=400&height=560&seq=card-6&orientation=portrait',
    tag: '完结佳作',
  },
];

export const faqData = [
  {
    question: '包子漫画收费吗？',
    answer: '完全免费！包子漫画平台所有漫画资源均为免费阅读，无需付费、无需会员、无需订阅，打开即可畅享海量漫画内容。我们通过广告收入维持运营，绝不影响用户的阅读体验。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '包子漫画全面支持手机、平板和电脑访问。推荐下载我们的移动APP获得最佳阅读体验，支持下拉式连贯阅读、夜间模式和离线下载功能，随时随地想看就看。',
  },
  {
    question: '漫画更新频率如何？',
    answer: '热门连载漫画每日同步更新，我们拥有专业的更新团队，确保与韩网、日网同步更新。一般作品更新时间为每日凌晨和下午两个时段，完结作品可一次性畅读全本。',
  },
  {
    question: '如何找到想看的漫画？',
    answer: '您可以通过首页搜索框输入漫画名称或作者名查找，也可以按分类（韩漫、日漫、国漫）浏览，或根据热门标签（恋爱、热血、悬疑等）筛选。我们还提供个性化推荐和排行榜帮助您发现好作品。',
  },
  {
    question: '可以下载漫画离线看吗？',
    answer: '可以！下载包子漫画APP后，您可以将喜欢的漫画章节缓存到本地，在没有网络的环境下也能畅快阅读。离线下载功能完全免费，不限制下载数量。',
  },
];

export const indexData = [
  { title: '热门韩漫', count: '12,860部', icon: 'ri-global-line' },
  { title: '经典日漫', count: '8,520部', icon: 'ri-earth-line' },
  { title: '精品国漫', count: '15,340部', icon: 'ri-building-2-line' },
  { title: '恋爱言情', count: '6,780部', icon: 'ri-heart-line' },
  { title: '热血动作', count: '9,210部', icon: 'ri-fire-line' },
  { title: '悬疑推理', count: '3,450部', icon: 'ri-search-eye-line' },
  { title: '搞笑喜剧', count: '5,890部', icon: 'ri-emotion-happy-line' },
];

export const commentsData = [
  {
    name: '漫画迷小王',
    content: '用了包子漫画快两年了，资源是真的全，更新也快，最爱的几部韩漫这里都能第一时间看到，推荐给所有喜欢看漫画的朋友！',
    rating: 5,
    date: '3天前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20anime%20style%20young%20male%20avatar%20portrait%2C%20friendly%20smile%2C%20clean%20background%2C%20minimalist%20style&width=80&height=80&seq=avatar-1&orientation=squarish',
  },
  {
    name: '追番小能手',
    content: '下拉式阅读体验太棒了，比翻页的阅读方式舒服太多了。而且完全免费这一点真的良心，希望平台越来越好！',
    rating: 5,
    date: '5天前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20anime%20style%20young%20female%20avatar%20portrait%2C%20cute%20expression%2C%20clean%20background%2C%20minimalist%20style&width=80&height=80&seq=avatar-2&orientation=squarish',
  },
  {
    name: '夜读党',
    content: '夜间模式对熬夜看漫画的人来说简直是救星！资源更新也很及时，每天的快乐源泉就是刷包子漫画看更新。',
    rating: 4,
    date: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20anime%20style%20teen%20avatar%20portrait%20with%20glasses%2C%20calm%20expression%2C%20clean%20background%2C%20minimalist%20style&width=80&height=80&seq=avatar-3&orientation=squarish',
  },
  {
    name: '漫画老司机',
    content: '从学生时代就开始看漫画，包子漫画是我用过最好的免费漫画平台。分类清晰，推荐精准，每次都能发现新的好作品。',
    rating: 5,
    date: '2周前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20anime%20style%20adult%20male%20avatar%20portrait%2C%20mature%20look%2C%20clean%20background%2C%20minimalist%20style&width=80&height=80&seq=avatar-4&orientation=squarish',
  },
  {
    name: '少女心爆棚',
    content: '恋爱漫画专区太赞了！推荐算法也很懂我，推的每部都戳中我的少女心。每天睡前必须刷几话才能安心睡觉~',
    rating: 5,
    date: '3周前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20anime%20style%20young%20girl%20avatar%20portrait%2C%20cheerful%20smile%2C%20pink%20tone%2C%20clean%20background%2C%20minimalist%20style&width=80&height=80&seq=avatar-5&orientation=squarish',
  },
];

export const updatesData = [
  {
    title: '《修罗武神》第320话更新',
    description: '楚枫终于突破天武境，与宿敌展开最终决战，燃爆全场！',
    time: '10分钟前',
    tag: '热门',
  },
  {
    title: '《女神降临》第185话',
    description: '修豪与晶晶的关系迎来新转机，三角恋情再起波澜。',
    time: '1小时前',
    tag: '新更',
  },
  {
    title: '《深渊游戏》第87话更新',
    description: '最终BOSS的真面目揭晓，所有玩家陷入前所未有的危机。',
    time: '2小时前',
    tag: '新更',
  },
  {
    title: '《社长大人请自重》第56话',
    description: '办公室秘密恋情曝光，社长霸气护妻场面高甜来袭。',
    time: '4小时前',
    tag: '热门',
  },
  {
    title: '《废柴逆天》第210话更新',
    description: '远古秘境全面开启，各方势力齐聚争夺传承机缘。',
    time: '6小时前',
    tag: '新更',
  },
  {
    title: '《天后进化论》第98话',
    description: '年度颁奖典礼震撼全场，女主角拿下大满贯创造历史。',
    time: '8小时前',
    tag: '新更',
  },
  {
    title: '《前世今生》第142话更新',
    description: '穿越千年的真相浮出水面，前世今生的羁绊令人泪目。',
    time: '12小时前',
    tag: '热门',
  },
];

export const rankingData = [
  { rank: 1, title: '女神降临', type: '韩漫 · 恋爱', hot: '9.8', change: 'up' },
  { rank: 2, title: '修罗武神', type: '国漫 · 玄幻', hot: '9.7', change: 'up' },
  { rank: 3, title: '我独自升级', type: '韩漫 · 热血', hot: '9.6', change: 'same' },
  { rank: 4, title: '社长大人请自重', type: '韩漫 · 言情', hot: '9.5', change: 'up' },
  { rank: 5, title: '深渊游戏', type: '日漫 · 悬疑', hot: '9.3', change: 'down' },
  { rank: 6, title: '天后进化论', type: '国漫 · 娱乐圈', hot: '9.2', change: 'up' },
];

export const mediaData = [
  {
    title: '《女神降临》动画化PV首曝',
    description: '国民级韩漫正式宣布动画化，制作团队集结业界顶尖人才，2026年冬季开播。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20PV%20style%20key%20visual%20of%20a%20beautiful%20Korean%20high%20school%20girl%20transformation%20scene%20with%20sparkling%20makeup%20effects%2C%20vibrant%20colors%2C%20animation%20style%20art%2C%20cinematic%20lighting&width=640&height=360&seq=media-1&orientation=landscape',
    duration: '03:25',
  },
  {
    title: '《我独自升级》第二季预告解析',
    description: '第二季战斗场面全面升级，"暗影军团"正式登场，猎人们将面对前所未有的强敌。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20style%20illustration%20of%20a%20dark%20warrior%20with%20shadow%20army%20behind%20him%2C%20intense%20action%20pose%2C%20blue%20energy%20effects%2C%20cinematic%20composition&width=640&height=360&seq=media-2&orientation=landscape',
    duration: '05:18',
  },
  {
    title: '包子漫画创作者访谈：对话人气画师',
    description: '独家专访多位平台人气漫画作者，揭秘创作背后的故事和新作计划，漫画迷不容错过。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Interview%20studio%20setup%20with%20drawing%20tablet%20and%20manga%20artwork%20displayed%20on%20screens%2C%20warm%20studio%20lighting%2C%20creative%20atmosphere%2C%20professional%20setting&width=640&height=360&seq=media-3&orientation=landscape',
    duration: '12:40',
  },
];

export const footerData = {
  description: '包子漫画 —— 国内领先的免费漫画在线阅读平台，提供海量免费韩漫、日漫、国漫资源，每日极速更新，下拉式畅快阅读，是漫画爱好者的首选免费看漫画平台。',
  links: [
    { label: '平台介绍', href: '#about' },
    { label: 'APP下载', href: '#app' },
    { label: '联系我们', href: '#contact' },
    { label: '常见问题', href: '#faq' },
    { label: '漫画索引', href: '#index' },
  ],
  copyright: '© 2026 包子漫画 baozimanhua.com 版权所有',
};